import React from 'react';

import Icon from 'carbon-react/lib/components/icon';

interface Props {
  isExcelDriver: boolean;
  isGroup?: boolean;
  name: string;
  withDragOffset?: boolean;
}

const GROUP_FONT_WEIGHT = 500;

export const DriverRowName = ({ isExcelDriver, isGroup, name, withDragOffset }: Props) => (
  <span
    style={{
      alignItems: 'center',
      display: 'inline-flex',
      fontWeight: isGroup ? GROUP_FONT_WEIGHT : undefined,
      gap: '8px',
      marginLeft: withDragOffset ? '8px' : undefined
    }}
  >
    <span>{name}</span>
    {isExcelDriver && <Icon type="file_excel"/>}
  </span>
);
